module.exports = __webpack_public_path__ + "images/home/product/features-report-aaf0da86f90dcfdc79d05871c12f4ebf.png";